import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';

/**
 * PriorityCountdown — ticks a "Reserved for you · Ns" chip down to zero.
 * When the timer hits 0, calls `onExpire()` so the parent can refresh the
 * available-orders list (that order will now be visible to all zone drivers).
 */
const PriorityCountdown = ({ expiresAt, onExpire, testid }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(t);
  }, []);

  const expiresMs = expiresAt ? new Date(expiresAt).getTime() : null;
  const remaining = (!expiresMs || isNaN(expiresMs))
    ? -1
    : Math.max(0, Math.ceil((expiresMs - now) / 1000));

  useEffect(() => {
    if (remaining === 0 && onExpire) onExpire();
  }, [remaining, onExpire]);

  if (remaining <= 0) return null;
  const label = remaining >= 60
    ? `${Math.floor(remaining / 60)}:${String(remaining % 60).padStart(2, '0')} left`
    : `${remaining}s left`;
  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider bg-emerald-900 text-emerald-100 px-1.5 py-0.5 rounded-full tabular-nums"
      data-testid={testid || 'priority-countdown'}
      title="Reserved for you — claim before another driver in your zone can"
    >
      <Timer className="h-2.5 w-2.5" /> {label}
    </span>
  );
};

export default PriorityCountdown;
